import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const STRESS_CONFIG = {
  High: {
    color: "#FF6445",
    height: { open: "72px", closed: "115px", },
    width: "13px"
  },
  Moderate: {
    color: "#FFE882",
    height: { open: "94px", closed: "91px" },
    width: "11px"
  },
  Low: {
    color: "#C8EDF5",
    height: { open: "64px", closed: "74px" },
    width: "8px"
  },
};

function EmotionChart({ stressChart, }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", overflowX: "auto", gap: 1, }}>

      {stressChart?.length == 0 && <Box sx={{ height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '10px' }}>No data available</Typography>
      </Box>}
      {/* Bars */}
      <Box
        sx={{
          overflowX: "auto",
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "max-content",
            minWidth: "100%",
            paddingX: 1,
          }}
        >{stressChart?.map((data, index) => {
          const config = STRESS_CONFIG[data.answer];
          if (!config) return null;

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                minWidth: "28px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mx: 0.4,

              }}
            >
              {/* Bar */}
              <Box
                sx={{
                  height: config.height.closed,
                  width: config.width,
                  backgroundColor: config.color,
                  borderRadius: 10,
                  boxShadow: 3,
                  marginBottom: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {data.hasDonePss && (
                  <Box
                    sx={{
                      width: 5,
                      height: 5,
                      backgroundColor: "#FFFFFF",
                      border: "0.2px solid #1599EA",
                      borderRadius: "100%",
                    }}
                  />
                )}
              </Box>

              {/* Date */}
              <Typography fontSize={"10px"} sx={{
                color: "#000", fontWeight: 'bold'
              }}>
                {moment(data.date).format("DD MMM")}
              </Typography>
            </Box>
          );
        })}
        </Box>
      </Box>

      {/* Legend */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: 'space-evenly',
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
          marginTop: 1,
        }}
      >
        {/* High */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FF6445" />
          <LegendText label="High Stress" />
        </Box>


        {/* Medium */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FFE882" />
          <LegendText label="Moderate Stress" />
        </Box>


        {/* Low */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#C8EDF5" />
          <LegendText label="Low Stress" />
        </Box>

        {/* PSS */}
        <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Dot color="#FFFFFF" border="0.2px solid #1599EA" />
          <LegendText label="PSS" />
        </Box>
      </Box>
    </Box>
  );
}

const Dot = ({ color, border, }) => (
  <Box
    sx={{
      width: 9,
      height: 9,
      borderRadius: "100%",
      backgroundColor: color,
      border: border || "none",
      marginRight: 0.5,
    }}
  />
);

const LegendText = ({ label, }) => (
  <Typography fontSize={"12px"} marginRight={1}>
    {label}
  </Typography>
);

export default EmotionChart;
